import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  cancelMultipleTrips,
  exportTrips,
  getTripList,
} from "../../services/trip.services";
import { getSearchAbleRoutes } from "../../services/route.services";
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CFormLabel,
  CFormInput,
  CButtonGroup,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CDropdown,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilPeople, cilPlus, cilTrash } from "@coreui/icons";
import CustomPagination from "../../components/CustomPagination";

import * as XLSX from "xlsx";

import Select from "react-select";
import { getUserList } from "src/services/user.services";
import { getActiveCountryList } from "src/services/country.services";
import TripTableData from "./TripTableData";
import useTableSort from "src/__custom_hook/useTableSort";
import toast from "react-hot-toast";
import { Document, pdf } from "@react-pdf/renderer";
import ExportTripPdfComponent from "./ExportTripPdfComponent";
import { useMutation } from "@tanstack/react-query";
import CreateTrip from "./CreateTrip";
import UpdateTrip from "./UpdateTrip";
const ManageTrip = () => {
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const { sortConfig, setSortConfig, handleClickColumnSort } = useTableSort();

  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(15);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);

  const [tripId, setTripId] = useState("");
  const [allDriverList, setAllDriverList] = useState([]);
  const [driverOptions, setDriverOptions] = useState([]);
  const [selectedTripDriver, setSelectedTripDriver] = useState(null);
  const [routeOptions, setRouteOptions] = useState([]);
  const [selectedTripRoute, setSelectedTripRoute] = useState(null);
  const [statusOptions, setStatusOptions] = useState("");
  const [selectedTripStatus, setSelectedTripStatus] = useState(null);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [countryOptions, setCountryOptions] = useState([]);
  const [createdAt, setCreatedAt] = useState("");
  const [selectAllStatus, setSelectAllStatus] = useState(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [editTripId, setEditTripId] = useState("");

  const cancelAllTripsMutation = useMutation({
    mutationKey: ["cancellAllTrips"],
    mutationFn: (data) => cancelMultipleTrips(data),
    onMutate: () => {
      toast.loading("Loading....");
    },
    onSuccess: (res) => {
      toast.dismiss();
      console.log(res);
      if (res.data.success) {
        setCurrentPage(1);
        getTripItem(1);
        setSelectAllStatus(false);
        setShowWarningModal(false);
        setSelectedCheckboxes([]);
        toast.success(res.data.message);
      }
    },
    onError: (error) => {
      toast.dismiss();
      toast.error(error?.response?.data?.message || "Something went wrong!");
    },
  });

  useEffect(() => {
    if (userInfo && userInfo.country)
      setSelectedCountry({
        value: userInfo.country._id,
        label: `${userInfo.country.name}-${userInfo.country.code}`,
      });

    if (userInfo?.userType === "superAdmin") {
      getActiveCountries();
    } else {
      getTripItem(currentPage);
      getRouteNameList();
      getDriverList("driver");
    }

    getStatusList();
  }, []);

  useEffect(() => {
    if (userInfo?.userType === "superAdmin") {
      if (selectedCountry) {
        getRouteNameList(null, selectedCountry.value);
        getDriverList("driver", null, selectedCountry.value);
      } else {
        getRouteNameList();
        getDriverList("driver");
        getTripItem(currentPage);
      }
    }
  }, [selectedCountry]);

  const handleSubmit = () => {
    setCurrentPage(1);
    getTripItem(1);
  };

  const handleReset = () => {
    setTripId("");
    setSelectedTripDriver("");
    setSelectedTripRoute("");
    setSelectedTripStatus("");
    if (selectedCountry) {
      setSelectedCountry(null);
    }
    setCreatedAt("");
    setCurrentPage(1);

    if (sortConfig.length > 0) {
      setSortConfig([]);
    }

    const param = {
      limit,
      page: 1,
      tripId,
      tripAssignedTo: "",
      tripRoute: "",
      tripStatus: "",
      country: "",
      createdAt: "",
      sort: "",
    };
    getTripItem(1, param);
  };

  //get all active countries
  const getActiveCountries = () => {
    getActiveCountryList({ limit: 100, page: 1, status: true })
      .then((response) => {
        if (response.success && response.data) {
          setCountries(response.data);
          let options = response.data.map((element) => ({
            value: `${element._id}`,
            label: `${element.name}`,
          }));
          setCountryOptions(options);
        }
      })
      .catch((error) => console.log(error));
  };

  const getTripItem = (page, param = null) => {
    const params = param
      ? param
      : {
          limit,
          page,
          tripId,
          tripAssignedTo: selectedTripDriver ? selectedTripDriver.value : "",
          tripRoute: selectedTripRoute ? selectedTripRoute.value : "",
          tripStatus: selectedTripStatus ? selectedTripStatus.value : "",
          country: selectedCountry ? selectedCountry.value : "",
          createdAt: createdAt,
          sort: sortConfig
            .map((config) => `${config.key}:${config.direction}`)
            .join(","),
        };
    setIsLoading(true);
    getTripList(params)
      .then(async (response) => {
        setCount(response.count);
        setData((prev) => response.data);
        if (selectAllStatus) {
          let newIds = [];
          response.data.map((item) => {
            if (
              !selectedCheckboxes.includes(item._id) &&
              item.tripStatus !== "completed"
            ) {
              newIds.push(item._id);
            }
          });
          if (newIds.length > 0) {
            setSelectedCheckboxes((prev) => [...prev, ...newIds]);
          }
        }
        const totalPages = Math.ceil(response.count / limit);
        setTotalPages(totalPages);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const getDriverList = (type, searchValue = "", country = "") => {
    let params = { type, q: searchValue, country };
    getUserList(params)
      .then((resp) => {
        let uesrList = resp.data;
        if (uesrList.length > 0) {
          setAllDriverList(uesrList);
          let optionsList = uesrList.map((item) => {
            return {
              value: item._id,
              label: `${item.firstName} ${item.lastName}`,
            };
          });
          setDriverOptions(optionsList);
        } else {
          setDriverOptions([]);
          setAllDriverList([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getRouteNameList = (searchString = "", country = "") => {
    getSearchAbleRoutes({ searchString, country })
      .then(async (response) => {
        const fetchedRouteData = response.data;
        let options = [];

        fetchedRouteData.forEach((element) => {
          const option = { value: `${element._id}`, label: `${element.name}` };
          options.push(option);
        });

        setRouteOptions(options);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getStatusList = () => {
    const statusObj = [
      { name: "Assigned", value: "assigned" },
      { name: "In Progress", value: "inProgress" },
      { name: "Completed", value: "completed" },
    ];
    let options = [];
    statusObj.forEach((element) => {
      const option = { value: `${element.value}`, label: `${element.name}` };
      options.push(option);
    });
    setStatusOptions(options);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    getTripItem(newPage);
  };

  const handleChangeDriver = (selectedOption) => {
    if (selectedOption) {
      setSelectedTripDriver(selectedOption);
    } else {
      setSelectedTripDriver("");
    }
  };

  const handleOnInputChangeUser = (searchValue) => {
    if (searchValue) {
      const matchingDrivers = allDriverList.filter(
        (item) =>
          item.firstName.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.lastName.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.email.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.designation.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.employeeCode.toLowerCase().includes(searchValue.toLowerCase())
      );
      if (matchingDrivers.length <= 0) {
        getDriverList("driver", searchValue);
      }
    } else {
      getDriverList("driver");
    }
  };

  const handleChangeRoute = (selectedOption) => {
    if (selectedOption) {
      setSelectedTripRoute(selectedOption);
    } else {
      setSelectedTripRoute("");
    }
  };
  const handleOnInputChangeRoute = (searchValue) => {
    const matchingRoutes = routeOptions.filter((route) =>
      route.label.toLowerCase().includes(searchValue.toLowerCase())
    );
    if (matchingRoutes.length <= 0) {
      getRouteNameList(searchValue);
    }
  };
  const handleChangeStatus = async (selectedOption) => {
    if (selectedOption) {
      setSelectedTripStatus(selectedOption);
    } else {
      setSelectedTripStatus("");
    }
  };
  const handleCountryChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedCountry(selectedOption);
    } else {
      setSelectedCountry(null);
    }
    setTripId("");
    setSelectedTripDriver("");
    setSelectedTripRoute("");
    setSelectedTripStatus("");
  };

  const exportToPDF = () => {
    toast.loading("Preparing downloads...");
    const params = {
      tripId,
      tripAssignedTo: selectedTripDriver ? selectedTripDriver.value : "",
      tripRoute: selectedTripRoute ? selectedTripRoute.value : "",
      tripStatus: selectedTripStatus ? selectedTripStatus.value : "",
      country: selectedCountry ? selectedCountry.value : "",
      createdAt: createdAt,
      sort: sortConfig
        .map((config) => `${config.key}:${config.direction}`)
        .join(","),
    };
    exportTrips(params)
      .then(async (response) => {
        let result = response.data.trips;
        let exportableData = [];

        result.forEach((element) => {
          let obj = {
            tripId: element.tripId,
            tripName: element?.tripName,
            orderCount: element.orderCount,
            booking_orders: element.booking_orders
              .map((order) => order.bookingOrderId)
              .join(", "),
            tripStartTime: element?.tripStartTime,
            createdAt: element?.createdAt,
            tripAssignedBy: element?.tripAssignedBy
              ? `${element?.tripAssignedBy?.firstName} ${element?.tripAssignedBy?.lastName}`
              : "",
            // tripVehicleId: element?.tripVehicleId,
            tripTagId: element?.tripTagId,
            tripRoute: element?.tripRoute,
            tripAssignedTo: element?.tripAssignedTo
              ? `${element?.tripAssignedTo?.firstName} ${element?.tripAssignedTo?.lastName}`
              : "",
            tripStatus: element.tripStatus,
            priority: element.priority,
            country: element?.country?.name,
            tripRemarks: element?.tripRemarks,
          };
          exportableData.push(obj);
        });

        const MyDocument = () => (
          <Document>
            <ExportTripPdfComponent data={exportableData} />
          </Document>
        );

        const pdfBlob = await pdf(<MyDocument />).toBlob();
        const pdfUrl = URL.createObjectURL(pdfBlob);

        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "Trips Report.pdf";
        link.click();

        toast.dismiss();
      })
      .catch((error) => {
        toast.dismiss();
        console.error(error);
      });
  };

  const exportToExcel = () => {
    toast.loading("Preparing downloads...");
    const params = {
      tripId,
      tripAssignedTo: selectedTripDriver ? selectedTripDriver.value : "",
      tripRoute: selectedTripRoute ? selectedTripRoute.value : "",
      tripStatus: selectedTripStatus ? selectedTripStatus.value : "",
      country: selectedCountry ? selectedCountry.value : "",
      createdAt: createdAt,
      sort: sortConfig
        .map((config) => `${config.key}:${config.direction}`)
        .join(","),
    };
    exportTrips(params)
      .then(async (response) => {
        let result = response.data.trips;
        let exportableData = [];

        result.forEach((element) => {
          let obj = {
            TripId: element.tripId,
            TripName: element?.tripName,
            "Total Order": element.orderCount,
            "Order Ids": element.booking_orders
              .map((order) => order.bookingOrderId)
              .join(", "),
            "Pickup Time": element?.tripStartTime,
            "Created Date": element?.createdAt,
            "Trip Created By": element?.tripAssignedBy
              ? `${element?.tripAssignedBy?.firstName} ${element?.tripAssignedBy?.lastName}`
              : "",
            "Tag Id": element?.tripTagId,
            "Route Name": element?.tripRoute?.name,
            "Route Code": element?.tripRoute?.routeCode,
            "Trip Driver": element?.tripAssignedTo
              ? `${element?.tripAssignedTo?.firstName} ${element?.tripAssignedTo?.lastName}`
              : "",
            Status: element.tripStatus,
            Status: element.status,
            Priority: element.priority,
            Country: element?.country?.name,
            Remarks: element?.tripRemarks,
          };
          exportableData.push(obj);
        });
        const worksheet = XLSX.utils.json_to_sheet(exportableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        const blob = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "Trips.xlsx");
        toast.dismiss();
      })
      .catch((error) => {
        toast.dismiss();
        console.error(error);
      });
  };

  const handleAllSelectCheckBox = (event) => {
    event.stopPropagation();
    event.preventDefault();

    if (userInfo.userType === "superAdmin" && !selectedCountry) {
      toast.error("Please select a country and try again");
      return;
    }

    // if (!bookingOrderSelectedStatus || !bookingOrderSelectedStatus.value) {
    //   toast.error("Please select a status and try again");b
    //   return;
    // }

    const isChecked = event.target.checked;

    setSelectAllStatus(isChecked);

    const selectedOders = data.reduce((ids, item) => {
      if (
        userInfo.userType === "superAdmin" &&
        selectedCountry?.value === item.country &&
        item.tripStatus !== "completed"
      ) {
        ids.push(item._id);
      }

      if (
        userInfo.userType !== "superAdmin" &&
        item.tripStatus !== "completed"
      ) {
        ids.push(item._id);
      }

      return ids;
    }, []);
    console.log(selectedOders);

    if (isChecked) {
      setSelectedCheckboxes(selectedOders);
    } else {
      setSelectedCheckboxes([]);
    }
  };

  const handleCheckBox = (event) => {
    event.stopPropagation();
    const { value } = event.target;
    if (selectAllStatus) {
      setSelectAllStatus(false);
    }
    if (selectedCheckboxes.includes(value)) {
      setSelectedCheckboxes(
        selectedCheckboxes.filter((item) => item !== value)
      );
    } else {
      setSelectedCheckboxes([...selectedCheckboxes, value]);
    }
  };

  const actionConfirmHandler = () => {
    const prepareData = {
      trips: selectedCheckboxes,
      selectAllStatus,
      country: selectedCountry ? selectedCountry.value : null,
    };
    console.log(prepareData);
    cancelAllTripsMutation.mutate(prepareData);
  };

  const handleEditTrip = (tripId) => {
    setEditTripId(tripId);
  };

  useEffect(() => {
    if (sortConfig.length > 0) {
      setCurrentPage(1);
      getTripItem(1);
    }
  }, [sortConfig]);

  return (
    <>
      {showWarningModal && (
        <CModal
          backdrop="static"
          visible={showWarningModal}
          onClose={() => {
            setShowWarningModal(false);
            setSelectedCheckboxes([]);
            setSelectAllStatus(false);
          }}
        >
          <CModalHeader closeButton>
            <CModalTitle>Trip Cancel Confirmation</CModalTitle>
          </CModalHeader>
          <CModalBody>
            {selectAllStatus
              ? `All "Assigned" and "InProgress" trips will be selected.`
              : `You have selected total ${selectedCheckboxes.length} trips`}
            . Are you sure you want to proceed?
          </CModalBody>
          <CModalFooter>
            <CButton
              color="dark"
              onClick={() => {
                setShowWarningModal(false);
                setSelectedCheckboxes([]);
                setSelectAllStatus(false);
              }}
            >
              Cancel
            </CButton>
            <CButton color="danger" onClick={actionConfirmHandler}>
              Confirm
            </CButton>
          </CModalFooter>
        </CModal>
      )}
      {editTripId && (
        <CModal
          size="xl"
          visible={!!editTripId}
          onClose={() => setEditTripId("")}
        >
          <CModalHeader closeButton>
            <CModalTitle>Edit Trip</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <UpdateTrip
              tripId={editTripId}
              {...{ setEditTripId, data, setData }}
            />
          </CModalBody>
        </CModal>
      )}
      <CCard className="mb-4">
        <CCardBody>
          <CRow className="mb-1">
            <CCol sm={12} md={3}>
              <CFormLabel htmlFor="bookingOrderId">Trip ID:</CFormLabel>
              <CFormInput
                type="text"
                value={tripId}
                onChange={(e) => setTripId(e.target.value)}
                placeholder="example:TRI001"
              />
            </CCol>
            <CCol sm={12} md={3}>
              <CFormLabel htmlFor="tripDriver">Select Driver:</CFormLabel>
              <Select
                id="tripDriver"
                onInputChange={handleOnInputChangeUser}
                value={selectedTripDriver}
                onChange={handleChangeDriver}
                options={driverOptions}
                isClearable={true}
                placeholder="select driver"
              />
            </CCol>

            <CCol sm={12} md={3}>
              <CFormLabel htmlFor="bookingOrderId">Route Name:</CFormLabel>
              <Select
                value={selectedTripRoute}
                onChange={handleChangeRoute}
                onInputChange={handleOnInputChangeRoute}
                options={routeOptions}
                isClearable={true}
              />
            </CCol>
            <CCol sm={12} md={3}>
              <CFormLabel htmlFor="bookingOrderId">Status:</CFormLabel>

              <Select
                value={selectedTripStatus}
                onChange={handleChangeStatus}
                options={statusOptions}
                isClearable={true}
              />
            </CCol>
          </CRow>

          <CRow className="mb-1">
            {userInfo && userInfo.userType === "superAdmin" && (
              <CCol sm={12} md={3}>
                <CFormLabel htmlFor="bookingOrderId">Country:</CFormLabel>

                <Select
                  value={selectedCountry}
                  onChange={handleCountryChange}
                  options={countryOptions}
                  isClearable={true}
                  isDisabled={userInfo.userType !== "superAdmin"}
                />
              </CCol>
            )}
            <CCol sm={12} md={3}>
              <CFormLabel>Date</CFormLabel>
              <CFormInput
                type="date"
                name="date"
                id="date"
                value={createdAt}
                onChange={(e) => setCreatedAt(e.target.value)}
              />
            </CCol>
          </CRow>

          <div className="d-flex justify-content-end mt-3">
            <CButton
              type="submit"
              color="primary"
              className="px-5 py-2 me-3"
              onClick={handleSubmit}
            >
              Submit
            </CButton>
            <CButton
              type="submit"
              className="px-5 py-2 ms-3 btn-oliveGreen"
              onClick={handleReset}
            >
              Reset
            </CButton>
          </div>
        </CCardBody>
      </CCard>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={8}>
              <h4 id="traffic" className="card-title mb-0">
                Trip Monitor - Total: {count}
              </h4>
            </CCol>
            <CCol sm={4}>
              <div className="d-flex justify-content-end gap-2">
                {selectedCheckboxes.length > 0 && (
                  <CButton
                    color="danger"
                    onClick={() => setShowWarningModal(true)}
                  >
                    <CIcon icon={cilTrash} />
                    &nbsp; Cancel Trip
                  </CButton>
                )}

                <Link to="/create-trip">
                  <CButton>
                    <CIcon icon={cilPlus} />
                    &nbsp; Create New Trip
                  </CButton>
                </Link>

                <CButtonGroup
                  role="group"
                  aria-label="Button group with nested dropdown"
                  style={{ marginRight: "10px" }}
                >
                  <CDropdown variant="btn-group">
                    <CDropdownToggle color="primary">Export</CDropdownToggle>
                    <CDropdownMenu>
                      <CDropdownItem
                        onClick={() => exportToPDF()}
                        style={{ cursor: "pointer" }}
                      >
                        as PDF
                      </CDropdownItem>
                      <CDropdownItem
                        onClick={() => exportToExcel()}
                        style={{ cursor: "pointer" }}
                      >
                        as Excel
                      </CDropdownItem>
                    </CDropdownMenu>
                  </CDropdown>
                </CButtonGroup>
                {/* <CButton onClick={exportToExcel}>Export</CButton> */}
              </div>
            </CCol>
          </CRow>
          <br />
          <TripTableData
            {...{
              isLoading,
              data,
              sortConfig,
              handleClickColumnSort,
              handleAllSelectCheckBox,
              selectAllStatus,
              userInfo,
              selectedCheckboxes,
              handleCheckBox,
              selectedCountry,
              handleEditTrip,
            }}
          />
          <br />
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </CCardBody>
      </CCard>
      {/* <CToaster ref={toaster} push={toast} placement="top-end"/> */}
    </>
  );
};

export default ManageTrip;
